<template>
  <d-button-group>
    <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow">
      <i class="fas fa-trash" style="margin-right: 5px"></i><span class="d-none d-lg-inline">Deletar</span>
    </d-button>
    <d-link size="sm" class="btn btn-primary" :to="{ name: 'admin-equipment-edit', params: { equipmentId: equipment.id }}">
      <i class="fas fa-edit" style="margin-right: 5px"></i><span class="d-none d-lg-inline">Editar</span>
    </d-link>
  </d-button-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_EQUIPMENT_ } from './EquipmentModel';

export default {
  name: 'equipment-buttons',
  props: {
    equipment: {
      type: Object,
      default: null,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_EQUIPMENT_, this.equipment);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-success {
  &:disabled {
    border-color: #ababab;
    background: #b8b8b8;
  }
}
</style>
